import React from 'react';
import { Link } from 'react-router-dom';
import { Quote, Download, ArrowRight } from 'lucide-react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText, EditableImage, HrefPill } from '../../components';
import { getIcon } from '../iconMap';

function PrincipalMessage({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const paragraphs = data.paragraphs || [];
  const updatePara = (i, t) => {
    const next = [...paragraphs];
    next[i] = t;
    update({ paragraphs: next });
  };
  const DLIcon = data.download_cta?.icon ? getIcon(data.download_cta.icon) : Download;
  return (
    <section className="py-24 bg-white">
      <div className="container-page grid lg:grid-cols-5 gap-12">
        <Reveal className="lg:col-span-2">
          <div className="lg:sticky lg:top-32">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 rounded-3xl bg-accent/20" />
              <EditableImage
                src={data.portrait?.src}
                alt={data.portrait?.alt || 'Principal'}
                onChange={(src, alt) => update({ portrait: { src, alt } })}
                className="relative rounded-3xl shadow-soft h-[480px] w-full object-cover"
              />
            </div>
            <div className="mt-6 p-6 rounded-2xl bg-olive-light">
              <EditableText value={data.from_label} onChange={(t) => update({ from_label: t })} as="div" className="text-xs uppercase tracking-[0.2em] text-olive font-semibold" />
              <EditableText value={data.portrait_name} onChange={(t) => update({ portrait_name: t })} as="div" className="font-display text-2xl mt-1 text-olive-deep" />
              <EditableText value={data.portrait_subtitle} onChange={(t) => update({ portrait_subtitle: t })} as="div" className="text-sm text-ink/60 mt-1" />
            </div>
            {data.download_cta && (
              <div className="mt-4">
                <Link to={data.download_cta.href || '#'} className="btn-ghost w-full"><DLIcon size={16} /> <EditableText value={data.download_cta.label} onChange={(t) => update({ download_cta: { ...(data.download_cta || {}), label: t } })} as="span" /></Link>
                <HrefPill value={data.download_cta.href} onChange={(h) => update({ download_cta: { ...(data.download_cta || {}), href: h } })} />
              </div>
            )}
          </div>
        </Reveal>

        <Reveal className="lg:col-span-3" delay={0.1}>
          <span className="eyebrow"><span className="h-px w-8 bg-olive" />
            <EditableText value={data.eyebrow} onChange={(t) => update({ eyebrow: t })} as="span" />
          </span>
          <h2 className="section-title mt-4">
            <EditableText value={data.heading} onChange={(t) => update({ heading: t })} as="span" />
          </h2>
          <Quote className="text-accent mt-8" size={48} />
          <div className="mt-4 space-y-6 text-ink/80 leading-relaxed text-lg">
            {paragraphs.map((p, i) => (
              <EditableText
                key={i}
                value={p}
                onChange={(t) => updatePara(i, t)}
                as="p"
                multiline
                className={i === 0 ? 'font-display italic text-xl text-olive-deep' : ''}
              />
            ))}
          </div>
          <div className="mt-10 pt-8 border-t border-olive/10 flex flex-wrap items-center justify-between gap-4">
            <EditableText value={data.signature} onChange={(t) => update({ signature: t })} as="div" className="font-display text-2xl text-olive-deep" />
            {data.apply_cta && (
              <div className="inline-flex flex-col">
                <Link to={data.apply_cta.href || '#'} className="btn-primary">
                  <EditableText value={data.apply_cta.label} onChange={(t) => update({ apply_cta: { ...(data.apply_cta || {}), label: t } })} as="span" />
                  <ArrowRight size={16} />
                </Link>
                <HrefPill value={data.apply_cta.href} onChange={(h) => update({ apply_cta: { ...(data.apply_cta || {}), href: h } })} />
              </div>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default PrincipalMessage;
